import { vsingleton } from '@niknevis/vue-modules'
import { ContentItemStepOneCollection } from '@/modules/content-item/models/content-item-collection.model'

@vsingleton()
export class PanelContentCampaignStore {
  private itemCopyModel: Partial<ContentItemStepOneCollection> = null

  get itemCopy(): Partial<ContentItemStepOneCollection> {
    return this.itemCopyModel
  }

  set itemCopy(value: Partial<ContentItemStepOneCollection>) {
    this.itemCopyModel = {
      title: value.title,
      main_keyword: value.main_keyword,
      keywords: value.keywords,
      word_count: value.word_count,
      content_type: value.content_type,
      tone: value.tone,
      description: value.description,
      ai_type: value.ai_type
    }
  }

  resetItemCopyModel() {
    this.itemCopyModel = {
      title: '',
      main_keyword: '',
      keywords: [],
      word_count: 1000,
      content_type: undefined,
      tone: undefined,
      description: '',
      ai_type: false
    }
  }
}
